<template>
  <div class="field-input-radio" v-if="fieldData.field_type === 'radio'">
    <div class="input-group">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <div v-for="(subItem, sKey) in fieldData.values" :key="sKey"
          class="btn-group-inner-div"
          v-bind:class="{'btn btn-outline-light': true,
          'active': (fieldData.field_value === subItem.internal_value)}"
          @click="changeFilterStatus(fieldData, subItem.internal_value)">
          <template v-if="subItem.visible && sKey == 0">
            <input
              :ref="fieldData.field_name"
              :name="fieldData.field_name + '_radio_option'"
              :id="fieldData.field_name + '_radio_option_' + sKey"
              type="radio"
              class="radio-input-field"
              :value="subItem.internal_value">
               <input
            v-show="false"
            :name="fieldData.field_name"
            :id="fieldData.field_name"
            type="text"
            class="form-control"
            v-model="fieldData.field_value"
            >
              <label :for="fieldData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
          </template>
          <template v-else-if="subItem.visible">
            <input
              :ref="fieldData.field_name"
              :name="fieldData.field_name + '_radio_option'"
              :id="fieldData.field_name + '_radio_option_' + sKey"
              type="radio"
              class="radio-input-field"
              :value="subItem.internal_value">
               <input
            v-show="false"
            :name="fieldData.field_name"
            :id="fieldData.field_name"
            type="text"
            class="form-control"
            v-model="fieldData.field_value"
            >
              <label :for="fieldData.field_name + '_radio_option_' + sKey">{{ subItem.display_value }}</label>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'widgetStyle'],
  methods: {
    changeFilterStatus(formData, switchVal) {
      if (formData.is_enabled) {
        const switchId = formData.field_name;
        if (document.getElementById(switchId).value === switchVal) {
          // this.$validator.validate(switchId);
          return;
        }
        document.getElementById(switchId).value = switchVal;
        this.fieldData.field_value = switchVal;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
/**NEW-TOM: Update color, background-color, border-color**/
  color: #FFFFFF;
  background-color: #00162B;
  border-color:#00162B;
}
.btn-outline-light {
/**NEW-TOM: Update color, border-color**/
  color: #333333;
  background-color: #FFFFFF;
  border-color: #CCCCCC;
  font-weight: 500;
}
.btn-group-toggle:focus-within {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.btn-outline-light:hover {
/**NEW-TOM: Update color, background-color, border-color**/
  background-color: #677580;
  color: #FFFFFF;
}
</style>

<style>
i.qrp-icon-font {
  font-family: 'Font Awesome 5 Pro', 'Font Awesome 5 Free';
  font-weight: 600;
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputRadioSwitchFilter.vue?00a57783